import React from 'react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/46114651766972:1';
export function FinalCTASection() {
  return <section className="relative bg-garden-dark py-14 px-4 sm:px-6 lg:px-8 text-center text-white overflow-hidden" data-id="element-22">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4wNSIvPjwvc3ZnPg==')] opacity-50" data-id="element-23"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-garden-medium/40 via-transparent to-transparent pointer-events-none" data-id="element-24"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-25">
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black mb-4 leading-tight drop-shadow-lg" data-id="element-26">
          🌱 Comer mejor puede empezar en tu casa
        </h2>
        <p className="text-lg sm:text-xl text-white/90 font-medium mb-5 max-w-2xl mx-auto" data-id="element-27">
          No necesitas más intentos. Solo empezar.
        </p>
        <p className="text-xl sm:text-2xl font-black text-earth-light mb-8 tracking-wide" data-id="element-28">
          👉 Empieza hoy con EL MANUAL DEL JARDINERO.
        </p>

        <div className="relative inline-block group" data-id="element-29">
          <div className="absolute -inset-1 bg-white rounded-full blur opacity-30 group-hover:opacity-60 transition duration-500 animate-pulse-glow" data-id="element-30"></div>
          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="relative inline-block bg-white hover:bg-neutral-bg text-garden-dark font-black text-lg sm:text-xl py-4 px-10 sm:px-14 rounded-full shadow-2xl transform transition-all duration-300 hover:-translate-y-1" data-id="element-31">
            SÍ, QUIERO ACCEDER AHORA
          </a>
        </div>
      </div>
    </section>;
}